export const TOOL_TASK = 'assign-user-entitlements';
export const TOOL_TITLE = 'Assign User Resources';
export const TOOL_PROGRESS_LABEL = 'Progress of assigning resources to the user...';
export const TOOL_STACK_OVERFLOW_MESSAGE = 'Please try again once assigning resources to the user finishes';
export const CONFLICT_TOOL_TITLE = 'Conflicting grants on resource';
export const MODAL_WIDTH = 800;
